// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Components
import { Div, FlexRow } from 'common/styles/oc-styled-components';
import { colors } from 'common/styles/style-constants';

import {
  DIMENSIONS,
  useWindowDimensions,
} from '../../../../providers/WindowDimensionsProvider';
import QuestionBubbleSvg from '../../../common/components/svgs/QuestionBubbleSvg';

// Other
import { getAndFilterLanguages } from '../../../common/helpers/common-helpers';

import { Language } from './styled-components';

const LanguagesNeedToKnow = ({ providers }) => {
  const languages = getAndFilterLanguages(providers);
  const { layout } = useWindowDimensions();
  return (
    <FlexRow
      align="center"
      margin={layout === DIMENSIONS.MOBILE ? '-.5em 0 -1em' : '-.5em 0 0'}
    >
      <Div width="40px">
        <QuestionBubbleSvg color={colors.blue} width="83px" />
      </Div>
      <Div margin="0 0 0 4.5em">
        {languages.map((language) =>
          <Language key={language}>{language}</Language>)}
      </Div>
    </FlexRow>
  );
};

LanguagesNeedToKnow.propTypes = {
  providers: PropTypes.array,
};

export default LanguagesNeedToKnow;
